import { render, staticRenderFns } from "./ExtendModal.vue?vue&type=template&id=98544b7e&scoped=true&"
import script from "./ExtendModal.vue?vue&type=script&lang=ts&"
export * from "./ExtendModal.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendModal.vue?vue&type=style&index=0&id=98544b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98544b7e",
  null
  
)

export default component.exports